import { Dispatch } from "redux";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { FormattedRelyingPartyConfig } from "@idw-types/data/relying-party-config";
import { setRelyingPartyDetails, setRelyingPartyDetailsLoading } from "@redux/actions/relying-party-details-actions";
import { getRelyingPartyRequest } from "@requests/axnadmin-core";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { formatRelyingPartyConfig } from "@formatters/relying-parties/relying-party-config-formatter";

export const getRelyingPartyDetailsReduxRequest = (dispatch: Dispatch) => async (
    relyingPartyId: string,
    companies: Array<AxnCompany>
): Promise<FormattedRelyingPartyConfig> => {
    dispatch(setRelyingPartyDetailsLoading(true));
    const { data, error } = await getRelyingPartyRequest(relyingPartyId);
    if (data) {
        const formattedRelyingParty = formatRelyingPartyConfig(data, companies);
        dispatch(setRelyingPartyDetails(formattedRelyingParty));
        return formattedRelyingParty;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getRelyingParties.error.title,
                resources.requests.getRelyingParties.error.message
            );
        }
        dispatch(setRelyingPartyDetailsLoading(false));
        return null;
    }
};